// extracted by mini-css-extract-plugin
export default {"container":"partner-accordion_container__2E-HW","container__img":"partner-accordion_container__img__RVFpP"};